// The plotter cursor of the plot line (R2705, ui-map-interface.md §12.0
// "The plot line").
//
// While the plot line stands, a press on the map adds a leg, so the
// pointer says so: the native cursor gives way to a teal plotter mark.
// The mark is the leg the press adds, as the plot layer draws it: a ring
// of the crosshair gap round the point, and the four arms of the pick
// crosshair outside it. It wears the patrol ink of `FLEET_ORDER_COLORS`,
// the ink of a loop leg, because LOOP is on when the plot line opens.
// Every figure is the pack's, so the mark has no number of its own.
//
// A finger has no cursor, so the mark is desktop sugar alone. The CSS
// value is built once, at the first call.

import { FLEET_CROSSHAIR, FLEET_ORDER_COLORS } from '../gen/presentation';

/** The hex form of a pack colour: `#35e0d2`. */
function hex(c: number): string {
  return `#${c.toString(16).padStart(6, '0')}`;
}

/** The SVG of the mark, a square `size` px a side with its point at the centre. */
export function plotCursorSvg(): { svg: string; size: number } {
  const x = FLEET_CROSSHAIR;
  const w = x.width;
  const c = Math.ceil(x.armPx + w);
  const size = c * 2;
  const ink = hex(FLEET_ORDER_COLORS.patrol.color);
  const arm = (x0: number, y0: number, x1: number, y1: number) =>
    `<line x1="${x0}" y1="${y0}" x2="${x1}" y2="${y1}"/>`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">`
    + `<g fill="none" stroke="${ink}" stroke-width="${w}" stroke-linecap="round">`
    + `<circle cx="${c}" cy="${c}" r="${x.gapPx}"/>`
    + arm(c - x.armPx, c, c - x.gapPx, c) + arm(c + x.gapPx, c, c + x.armPx, c)
    + arm(c, c - x.armPx, c, c - x.gapPx) + arm(c, c + x.gapPx, c, c + x.armPx)
    + '</g></svg>';
  return { svg, size };
}

let css = '';

/** The CSS `cursor` value of the plot line: the mark, its hot spot at the
 *  centre, and the crosshair of the browser where an image cursor fails. */
export function plotCursor(): string {
  if (css) return css;
  const { svg, size } = plotCursorSvg();
  css = `url("data:image/svg+xml,${encodeURIComponent(svg)}") ${size / 2} ${size / 2}, crosshair`;
  return css;
}
